// removed by extract-text-webpack-plugin
module.exports = {"react-switch-checkbox":"Switch__react-switch-checkbox___2tgED","react-switch-label":"Switch__react-switch-label___2IdRs","react-switch-button":"Switch__react-switch-button___15b5h","slider":"Switch__slider___1-yi7","round":"Switch__round___2_1jB","switch":"Switch__switch___2q0Rq"};


//////////////////
// WEBPACK FOOTER
// ./seazit/assets/seazit/widgets/Switch.css
// module id = 1118
// module chunks = 1